import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../createApiConfig';

export const VideoApi = createApi({
  reducerPath: 'VideoApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Video','duration','type'],
  endpoints: (builder) => ({
    listVideos: builder.query({
      query: (params) => ({
        url: `/videos/`,
        params,
      }),
      
    }),

    createVideo: builder.mutation({
      query: (data) => ({
        url: `/videos/`,
        method: 'POST',
        body: data,
      }),
    }),

    updateVideo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/videos/${id}/`,
        method: 'PATCH',
        body: data,
      }),
    }),

    listVideosBulk: builder.query({
      query: (params) => ({
        url: `/videos/bulk/`,
        params,
      }),
      
    }),

    createVideoBulk: builder.mutation({
      query: (data) => ({
        url: `/videos/bulk/`,
        method: 'POST',
        body: data,
      }),
    }),

    updateVideoBulk: builder.mutation({
      query: (data) => ({
        url: `/videos/bulk/`,
        method: 'PATCH',
        body: data,
      }),
    }),

    listVideosDuration: builder.query({
      query: (params) => ({
        url: `/videos/durations/`,
        params,
      }),
      providesTags:['duration']
    }),

    createVideoDuration: builder.mutation({
      query: (data) => ({
        url: `/videos/durations/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['duration'],
    }),

    updateVideoDuration: builder.mutation({
      query: ({ id, data }) => ({
        url: `/videos/durations/${id}/`,
        method: 'PATCH',
        body: data,
      }),
       invalidatesTags: ['duration'],
    }),

    listVideosTypes: builder.query({
      query: (params) => ({
        url: `/videos/types/`,
        params,
      }),
      
      providesTags:['type']
    }),

    createVideoTypes: builder.mutation({
      query: (data) => ({
        url: `/videos/types/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags:['type']
    }),

    updateVideoTypes: builder.mutation({
      query: ({ id, data }) => ({
        url: `/videos/types/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags:['type']
    }),

    updateVideoDates: builder.mutation({
      query: (data) => ({
        url: `/videos/update-dates/`,
        method: 'PATCH',
        body: data,
      }),
    }),

    updateVideoStats: builder.mutation({
      query: (data) => ({
        url: `/videos/update-stats/`,
        method: 'PATCH',
        body: data,
      }),
    }),

    updateVideoFields: builder.mutation({
      query: (data) => ({
        url: `/videos/update-fields/`,
        method: 'PATCH',
        body: data,
      }),
    }),
  }),
});

export const {
  useListVideosQuery,
  useLazyListVideosQuery,
  useCreateVideoMutation,
  useUpdateVideoMutation,

  useListVideosBulkQuery,
  useCreateVideoBulkMutation,
  useUpdateVideoBulkMutation,

  useListVideosDurationQuery,
  useCreateVideoDurationMutation,
  useUpdateVideoDurationMutation,

  useListVideosTypesQuery,
  useCreateVideoTypesMutation,
  useUpdateVideoTypesMutation,

  useUpdateVideoDatesMutation,
  useUpdateVideoStatsMutation,
  useUpdateVideoFieldsMutation,
} = VideoApi;
